import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 8 10",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.5 3.33333H7C7.55 3.33333 8 3.7619 8 4.28571V9.04762C8 9.57143 7.55 10 7 10H1C0.45 10 0 9.57143 0 9.04762V4.28571C0 3.7619 0.45 3.33333 1 3.33333H1.5V2.38095C1.5 1.04762 2.6 0 4 0C5.4 0 6.5 1.04762 6.5 2.38095V3.33333ZM2.45 2.38095V3.33333H5.55V2.38095C5.55 1.57143 4.85 0.904762 4 0.904762C3.15 0.904762 2.45 1.57143 2.45 2.38095ZM5 6.66661C5 7.19042 4.55 7.619 4 7.619C3.45 7.619 3 7.19042 3 6.66661C3 6.1428 3.45 5.71423 4 5.71423C4.55 5.71423 5 6.1428 5 6.66661Z"
    }, null, -1)
  ])))
}
export default { render: render }